import React from 'react';
import { useRecordContext, useGetList } from 'react-admin';
import { Box, Chip } from '@mui/material';
import { orgsFields } from '../../orgs.model';
import EmptyField from '../../../material/emptyField.component';
import { US_STATES_RESOURCE_NAME } from '../../../usStates/usStates.dataProvider';

const OrderedUsStates = () => {
    const record = useRecordContext();
    if (!record || !record[orgsFields.usStates]) return <EmptyField />;
    const usIds = record[orgsFields.usStates];

    if (usIds.length === 0) return <EmptyField />;

    const { data: states, isLoading } = useGetList(
        US_STATES_RESOURCE_NAME,
        { limit: 100 }
    );

    if (isLoading) return null;

    const usStates = states.filter(state => usIds.includes(state.id));

    return (
        <Box>
            {usStates.map((state) => {
                return (
                    <Chip 
                        key={state.id}
                        label={state.name}
                        sx={{ mr: 1, mb: 1 }}
                    />
                );
            })}
        </Box>
    );
};

export default OrderedUsStates; 